export enum CustomFieldsEvents {
  SettingsUpdated = 'settingsUpdated'
}
